import { createAction } from '@reduxjs/toolkit';
export const SYSTEM_SUSPEND = 'SYSTEM_SUSPEND';
export const systemSuspendAction = createAction(SYSTEM_SUSPEND);